if($('#app-ratings-dashboard').length > 0){
    function ratings_tv_books_format ( d ) {
        var html = '<h5>Available Books:</h5><div class="row">';
        if(typeof d['name'] !== 'undefined'){
            html += '<div class="col-lg-3"><div class="well well-sm text-center">' + d['name'] + '</div></div>';
        }else {
            $.each(d, function (index, value) {
                var aux = collect(value).groupBy('service').toArray();
                console.log("aux");
                console.log(aux);
                if(typeof aux[0] !== 'undefined' && typeof aux[0][0] !== 'undefined')
                    html += '<div class="col-lg-3"><div class="well well-sm text-center">' + aux[0][0] ['name'] + ((aux[0][0] ['service'] === "NSIX") ? " Impact Data" : "") + '</div></div>';
                if(typeof aux[1]  !== 'undefined' && typeof aux[1][0]  !== 'undefined')
                    html += '<div class="col-lg-3"><div class="well well-sm text-center">' + aux[1][0] ['name'] + ((aux[1][0] ['service'] === "NSIX") ? " Impact Data" : "") + '</div></div>';
            });
        }

        html += '</div>';
        return html;
    }

    if($('#app-nielsen-tv-markets-table').length !== 0){
        var ratings_tv_markets;
        var ratings_tv_books = {};
        var ratings_tv_markets_table;

        $(document).ready(function(){
            show_loader();
            $.ajax({
                type: "GET",
                url: '/ratings/tv/local/markets',
                dataType: 'json',
                success: function (data) {
                    ratings_tv_markets = data;

                    ratings_tv_markets_table = $('#app-nielsen-tv-markets-table').DataTable({
                        data: ratings_tv_markets,
                        "order": [[ 1, "asc" ]],
                        pageLength: user_entries,
                        columns: [
                            {
                                "className":      'details-control',
                                "orderable":      false,
                                "data":           null,
                                "defaultContent": ''
                            },
                            {
                                data: 'dma',
                                name: 'dma',
                                title: 'DMA Code'
                            },
                            {
                                data: 'name',
                                name: 'name',
                                title: 'Name'
                            },
                            {
                                data: 'type',
                                name: 'type',
                                title: 'Type'
                            },
                            {
                                data: 'class_code',
                                name: 'class',
                                title: 'Class'
                            },
                            {
                                name: 'buttons',
                                "className":      'buttons',
                                "orderable":      false,
                                "data":           null,
                                "defaultContent": '',
                                "createdCell": function (td, cellData, rowData, row, col) {
                                    //if(permited == 1){
                                    var html = '<div class="row text-center">' +
                                        '<a href="/ratings/tv/vendors/' +
                                        cellData['dma'] +
                                        '" role="button" class="btn btn-info btn-sm">' +
                                        '<i class="fa fa-shopping-cart fa-fw"></i> Vendors' +
                                        '</a>' +
                                        '</div>';
                                    //}
                                    //else
                                    //    var html='';
                                    $(td).html(html);
                                }
                            }
                        ],
                    });

                    $('#app-nielsen-tv-markets-table tbody').on('click', 'td.details-control', function () {
                        var tr = $(this).closest('tr');
                        var row = ratings_tv_markets_table.row( tr );

                        if ( row.child.isShown() ) {
                            $(this).removeClass('open');
                            row.child.hide();
                            tr.removeClass('shown');
                        }
                        else {
                            var row_data = row.data();
                            if(typeof ratings_tv_books[row_data['dma']] === 'undefined'){
                                show_loader();
                                $.ajax({
                                    type: "GET",
                                    url: '/ratings/tv/local/monthly/allbooks/?dma=' + row_data['dma'],
                                    dataType: 'json',
                                    success: function (data) {
                                        data = collect(data).groupBy('name').toArray();
                                        console.log("groupby");
                                        console.log(data);
                                        ratings_tv_books[row_data['dma']] = data;
                                        row.child( ratings_tv_books_format(data) ).show();

                                        hide_loader();
                                    },
                                    error: function (xhr) {
                                        ajax_error();
                                        hide_loader();
                                    }
                                });
                            }else{
                                row.child( ratings_tv_books_format(ratings_tv_books[row_data['dma']]) ).show();
                            }
                            $(this).addClass('open');
                            tr.addClass('shown');


                        }
                    } );
                    hide_loader();
                },
                error: function (xhr) {
                    ajax_error();
                    hide_loader();
                }
            });
        });
    }

    function ratings_radio_books_format ( d ) {
        console.log(d);
        var html = '<h5>Available Books:</h5><div class="row">';
        if(typeof d['name'] !== 'undefined'){
            html += '<div class="col-lg-3"><div class="well well-sm text-center">' + d['name'] + '</div></div>';
        }else {
            var dates_ordered= d;
            console.log('dates_ordered  ', dates_ordered);
            var OrdDates= Object.entries(dates_ordered).sort((a,b) => (moment(a[1].start) > moment(b[1].start)) ? 1 : ((moment(b[1].start) > moment(a[1].start)) ? -1 : 0));
            var cont = OrdDates.length - 1;
            console.log('OrdDates ', OrdDates);
            console.log('cont ', cont);
            if(typeof OrdDates[0][1] !== 'undefined')
                 var value = OrdDates[0][1];
            else
                var value = [];
            console.log('value ', value);
            if(typeof value['name'] !== 'undefined')
                html += '<div class="col-lg-3"><div class="well well-sm text-center">' + value['name'] + '</div></div>';
            else {
                for (var i in value)
                    html += '<div class="col-lg-3"><div class="well well-sm text-center">' + value[i]['name'] + '</div></div>';
            }

            //$.each(d, function (index, value) {
             //   html += '<div class="col-lg-3"><div class="well well-sm text-center">' + value['name'] + '</div></div>';
           // });
        }

        html += '</div>';
        return html;
    }

    if($('#app-nielsen-radio-markets-table').length !== 0) {
        var ratings_radio_markets;
        var ratings_radio_books = {};
        var ratings_radio_markets_table;

        $(document).ready(function(){
            show_loader();
            $.ajax({
                type: "GET",
                url: '/ratings/radio/markets',
                dataType: 'json',
                success: function (data) {
                    ratings_radio_markets = data;

                    ratings_radio_markets_table = $('#app-nielsen-radio-markets-table').DataTable({
                        data: ratings_radio_markets,
                        "order": [[ 1, "asc" ]],
                        pageLength: user_entries,
                        columns: [
                            {
                                "className":      'details-control',
                                "orderable":      false,
                                "data":           null,
                                "defaultContent": ''
                            },
                            {
                                data: 'code',
                                name: 'msa',
                                title: 'MSA Code'
                            },
                            {
                                data: 'name',
                                name: 'name',
                                title: 'Name'
                            },
                            {
                                data: 'type',
                                name: 'type',
                                title: 'Type'
                            },
                            {
                                data: 'frequency',
                                name: 'frequency',
                                title: 'Book Frequency'
                            },
                            {
                                name: 'buttons',
                                "className":      'buttons',
                                "orderable":      false,
                                "data":           null,
                                "defaultContent": '',
                                "createdCell": function (td, cellData, rowData, row, col) {

                                    // if(permited == 1){
                                        var html = '<div class="row text-center">' +
                                            '<a href="/ratings/radio/vendors/' +
                                            cellData['code'] +
                                            '" role="button" class="btn btn-info btn-sm">' +
                                            '<i class="fa fa-shopping-cart fa-fw"></i> Vendors' +
                                            '</a>' +
                                            '</div>';
                                    // }else
                                    //     var html='';
                                    $(td).html(html);
                                }
                            }
                        ],
                    });

                    $('#app-nielsen-radio-markets-table tbody').on('click', 'td.details-control', function () {
                        var tr = $(this).closest('tr');
                        var row = ratings_radio_markets_table.row( tr );

                        if ( row.child.isShown() ) {
                            $(this).removeClass('open');
                            row.child.hide();
                            tr.removeClass('shown');
                        }
                        else {
                            var row_data = row.data();
                            if(typeof ratings_radio_books[row_data['code']] === 'undefined'){
                                show_loader();
                                $.ajax({
                                    type: "GET",
                                    url: '/ratings/radio/books/?code=' + row_data['code'],
                                    dataType: 'json',
                                    success: function (data) {
                                        console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^');
                                        console.log(data);
                                        data = collect(data).sortBy('start', 'desc').toArray();
                                        console.log(data);

                                        ratings_radio_books[row_data['code']] = data;
                                        row.child(ratings_radio_books_format(data)).show();

                                        hide_loader();
                                    },
                                    error: function (xhr) {
                                        ajax_error();
                                        hide_loader();
                                    }
                                });
                            }else{
                                console.log("undefined");
                                row.child( ratings_radio_books_format(ratings_radio_books[row_data['code']]) ).show();
                            }
                            $(this).addClass('open');
                            tr.addClass('shown');


                        }
                    } );
                    hide_loader();
                },
                error: function (xhr) {
                    ajax_error();
                    hide_loader();
                }
            });
        });
    }
}

if($('#app-eastlan-ratings-dashboard').length > 0){

    function ratings_radio_books_format ( d ) {
        console.log(d);
        var html = '<h5>Available Books:</h5><div class="row">';
        if(typeof d['name'] !== 'undefined'){
            html += '<div class="col-lg-3"><div class="well well-sm text-center">' + d['name'] + '</div></div>';
        }else {
            var dates_ordered= d;
            console.log('dates_ordered  ', dates_ordered);
            var OrdDates= Object.entries(dates_ordered).sort((a,b) => (moment(a[1].start) > moment(b[1].start)) ? 1 : ((moment(b[1].start) > moment(a[1].start)) ? -1 : 0));
            var cont = OrdDates.length - 1;
            console.log('OrdDates ', OrdDates);
            console.log('cont ', cont);
            if(typeof OrdDates[0][1] !== 'undefined')
                var value = OrdDates[0][1];
            else
                var value = [];
            console.log('value ', value);
            if(typeof value['name'] !== 'undefined')
                html += '<div class="col-lg-3"><div class="well well-sm text-center">' + value['name'] + '</div></div>';
            else {
                for (var i in value)
                    html += '<div class="col-lg-3"><div class="well well-sm text-center">' + value[i]['name'] + '</div></div>';
            }

            //$.each(d, function (index, value) {
            //   html += '<div class="col-lg-3"><div class="well well-sm text-center">' + value['name'] + '</div></div>';
            // });
        }

        html += '</div>';
        return html;
    }

    if($('#app-eastlan-radio-markets-table').length !== 0) {
        var ratings_radio_markets;
        var ratings_radio_books = {};
        var ratings_radio_markets_table;

        $(document).ready(function(){
            show_loader();
            $.ajax({
                type: "GET",
                url: '/ratings/eastlan-radio/markets',
                dataType: 'json',
                success: function (data) {
                    ratings_radio_markets = data;

                    ratings_radio_markets_table = $('#app-eastlan-radio-markets-table').DataTable({
                        data: ratings_radio_markets,
                        "order": [[ 1, "asc" ]],
                        pageLength: user_entries,
                        columns: [
                            {
                                "className":      'details-control',
                                "orderable":      false,
                                "data":           null,
                                "defaultContent": ''
                            },
                            {
                                data: 'code',
                                name: 'msa',
                                title: 'MSA Code'
                            },
                            {
                                data: 'name',
                                name: 'name',
                                title: 'Name'
                            },
                            {
                                data: 'type',
                                name: 'type',
                                title: 'Type'
                            },
                            {
                                data: 'frequency',
                                name: 'frequency',
                                title: 'Book Frequency'
                            },
                            {
                                name: 'buttons',
                                "className":      'buttons',
                                "orderable":      false,
                                "data":           null,
                                "defaultContent": '',
                                "createdCell": function (td, cellData, rowData, row, col) {

                                    // if(permited == 1){
                                        var html = '<div class="row text-center">' +
                                            '<a href="/ratings/eastlan-radio/vendors/' +
                                            cellData['code'] +
                                            '" role="button" class="btn btn-info btn-sm">' +
                                            '<i class="fa fa-shopping-cart fa-fw"></i> Vendors' +
                                            '</a>' +
                                            '</div>';
                                    // }else
                                    //     var html='';
                                    $(td).html(html);
                                }
                            }
                        ],
                    });

                    $('#app-eastlan-radio-markets-table tbody').on('click', 'td.details-control', function () {
                        var tr = $(this).closest('tr');
                        var row = ratings_radio_markets_table.row( tr );

                        if ( row.child.isShown() ) {
                            $(this).removeClass('open');
                            row.child.hide();
                            tr.removeClass('shown');
                        }
                        else {
                            var row_data = row.data();
                            if(typeof ratings_radio_books[row_data['code']] === 'undefined'){
                                show_loader();
                                $.ajax({
                                    type: "GET",
                                    url: '/ratings/radio/books/?code=' + row_data['code'],
                                    dataType: 'json',
                                    success: function (data) {
                                        console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^');
                                        console.log(data);
                                        data = collect(data).sortBy('start', 'desc').toArray();
                                        console.log(data);

                                        ratings_radio_books[row_data['code']] = data;
                                        row.child(ratings_radio_books_format(data)).show();

                                        hide_loader();
                                    },
                                    error: function (xhr) {
                                        ajax_error();
                                        hide_loader();
                                    }
                                });
                            }else{
                                console.log("undefined");
                                row.child( ratings_radio_books_format(ratings_radio_books[row_data['code']]) ).show();
                            }
                            $(this).addClass('open');
                            tr.addClass('shown');
                        }
                    } );
                    hide_loader();
                },
                error: function (xhr) {
                    ajax_error();
                    hide_loader();
                }
            });
        });
    }
}

if($('#app-comscore-dashboard').length > 0){
    function ratings_tv_books_format ( d ) {
        var html = '<h5>Available Books:</h5><div class="row">';
        if(typeof d['name'] !== 'undefined'){
            html += '<div class="col-lg-3"><div class="well well-sm text-center">' + d['name'] + '</div></div>';
        }else {
            $.each(d, function (index, value) {
                html += '<div class="col-lg-3"><div class="well well-sm text-center">' + value[0]['name'] + '</div></div>';
            });
        }

        html += '</div>';
        return html;
    }

    if($('#app-comscore-tv-markets-table').length !== 0){
        var ratings_tv_markets;
        var ratings_tv_books = {};
        var ratings_tv_markets_table;

        $(document).ready(function(){
            show_loader();
            $.ajax({
                type: "GET",
                url: '/ratings/comscore/tv/local/markets',
                dataType: 'json',
                success: function (data) {
                    ratings_tv_markets = data;

                    ratings_tv_markets_table = $('#app-comscore-tv-markets-table').DataTable({
                        data: ratings_tv_markets,
                        "order": [[ 1, "asc" ]],
                        pageLength: user_entries,
                        columns: [
                            {
                                data: 'dma',
                                name: 'dma',
                                title: 'DMA Code'
                            },
                            {
                                data: 'name',
                                name: 'name',
                                title: 'Name'
                            },
                            {
                                data: 'type',
                                name: 'type',
                                title: 'Timezone'
                            },
                            {
                                name: 'buttons',
                                "className":      'buttons',
                                "orderable":      false,
                                "data":           null,
                                "defaultContent": '',
                                "createdCell": function (td, cellData, rowData, row, col) {
                                    if(cellData['name'] !== 'National' && cellData['name'] !== 'National (National)'){
                                        var html = '<div class="row text-center">' +
                                            '<a href="/ratings/comscore/tv/vendors/' +
                                            cellData['dma'] +
                                            '" role="button" class="btn btn-info btn-sm">' +
                                            '<i class="fa fa-shopping-cart fa-fw"></i> Vendors' +
                                            '</a>' +
                                            '</div>';
                                    }
                                    else
                                        var html='';
                                    $(td).html(html);
                                }
                            }
                        ],
                    });
                    hide_loader();
                },
                error: function (xhr) {
                    ajax_error();
                    hide_loader();
                }
            });
        });
    }
}
